import { useEffect, useContext } from "react"; // Removed unused import 'useState'
import { useSearchParams } from 'react-router-dom';
import { CardContext } from "../context/CardContext";
import Card from "../components/card/Card";

function CardPage({ func }) { // Destructured 'func' from props
  const [searchParams] = useSearchParams();
  const title = searchParams.get('title');
  const cat = searchParams.get('cat');
  const uri = searchParams.get('uri');
  const input = searchParams.get('input');
  const hasInput = searchParams.get('hasinput') === 'true';

  const { setCardOpen, setCardContent, setCardBlocksNew } = useContext(CardContext);

  useEffect(() => {
    setCardOpen(true);
  }, [setCardOpen]);

  useEffect(() => {
    func('Portal'); // Used destructured 'func' directly
    setCardContent({
      title: title,
      cat: cat,
      input: input,
      uri: uri,
      color: '#000000',
      hasInput: hasInput,
      goesBack: false
    });
  }, [cat, setCardContent, title, uri, input, hasInput, func]); // Added 'func' to the dependency array

  useEffect(() => {
    fetch("/portal/conf_info")
      .then(res => {
        if (!res.ok) {
          throw new Error('Failed to fetch data');
        }
        return res.json();
      })
      .then(data => setCardBlocksNew(data.cards))
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [setCardBlocksNew]);

  return (
    <Card></Card>
  );
}

export default CardPage;
